import { constantsTypes } from "../reduxConstants";

const initialValue = { value: 0 };

export const logindataValue = (state = initialValue, action) => {
  switch (action.type) {
    case constantsTypes.LOGIN_DATA:
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};
